export default __webpack_public_path__ + "static/media/34.ef1057c6.png";